import { useQuery } from "react-query";
import { fetchReminderNotes } from "@/services/tasks";
/** Query hook for the paginated notes list of a reminder. */
export function useReminderNotes(patientUid, reminderId) {
  return useQuery(["reminder-notes", patientUid, reminderId], function () {
    return fetchReminderNotes(patientUid, reminderId);
  }, {
    enabled: Boolean(patientUid && reminderId)
  });
}